import React from 'react';
import {
    Page,
    SkeletonBodyText,
    Card,
    Banner,
    Link,
    Select
} from '@shopify/polaris';
import OperationPreviewComponent from '../../components/OperationPreviewComponent';
import TagViewComponent from '../../components/TagViewComponent';
import { apiFetch as fetch } from '../../common/Helpers';
import { Helmet } from 'react-helmet';

class ScenarioRemovePage extends React.Component {

    state = {
        step: null,
        isLoading: true,
        tagsToRemove: [],
        resourceType: "Product",
        data: null,
        preview: null
    };

    render() {

        if (this.state.step == null) {
            return (<div>
                <Helmet>
                    <title>Tag Genie - Bulk Remove Tags</title>
                </Helmet>
                <Page title="Bulk Remove Tags">
                    <SkeletonBodyText lines="20" />
                </Page>
            </div>)
        }

        let hasTagsToRemove = this.state.tagsToRemove.length > 0;
        const resourceTypes = [
            { label: 'Customer', value: 'Customer' },
            { label: 'Product', value: 'Product' },
            { label: 'Order', value: 'Order' },
        ];
        let resourcePlural = "products";
        let resourceSingular = "product";

        if (this.state.resourceType === "Customer") {
            resourcePlural = "customers";
            resourceSingular = "customer";
        }

        if (this.state.resourceType === "Order") {
            resourcePlural = "orders";
            resourceSingular = "order";
        }

        return (
            <div>
                <Helmet>
                    <title>Tag Genie - Bulk Remove Tags</title>
                </Helmet>

                {this.state.step === "create" &&
                    <Page title="Bulk Remove Tags">
                        <Card primaryFooterAction={{ content: 'Preview Remove Tags', disabled: !hasTagsToRemove || this.state.isLoading, onAction: this.handlePreview, loading: this.state.isLoading }}>
                            <Card.Section>
                                <Banner>
                                    <p>If you require more advanced functionality, consider using a <Link url="/operations/new/custom">Custom Tag Operation</Link>.
                                    </p>
                                </Banner>
                            </Card.Section>
                            <Card.Section title="Resource type">
                                <Select options={resourceTypes} value={this.state.resourceType} onChange={this.onResourceChange} />
                            </Card.Section>
                            <Card.Section title="Store tags">
                                <TagViewComponent
                                    showMarkUnmark={true}
                                    canSelect={true}
                                    tags={this.getActiveTags()}
                                    selectedTags={this.state.tagsToRemove}
                                    selectedTagsState="removed"
                                    onSelectedChange={this.handleSelectedTagsChange}
                                    tagActionText="Click on a tag to select it for being merged." />
                            </Card.Section>
                        </Card>
                    </Page>
                }

                {this.state.step === "preview" &&
                    <Page title="Bulk Remove Tags - Preview">
                        <Card
                            title="Preview tag operation"
                            primaryFooterAction={{ content: "Execute Remove Tags", disabled: !this.state.preview.canExecute || this.state.isLoading, onAction: this.handleSubmit, loading: this.state.isLoading }}
                            secondaryFooterActions={[{ content: 'Back', disabled: this.state.isLoading, onAction: this.handleBack }]}>
                            <OperationPreviewComponent
                                preview={this.state.preview}
                                resourcePlural={resourcePlural}
                                resourceSingular={resourceSingular} />
                        </Card>
                    </Page>}
            </div>
        );
    }

    handleSelectedTagsChange = (newSelectedTags) => {
        this.setState({
            tagsToRemove: newSelectedTags
        })
    }

    getActiveTags = () => {
        if (this.state.resourceType === "Product") {
            return this.state.data.tags;
        }

        if (this.state.resourceType === "Customer") {
            return this.state.data.customerTags;
        }

        if (this.state.resourceType === "Order") {
            return this.state.data.orderTags;
        }

        return [];
    }

    onResourceChange = (value) => {
        this.setState({
            resourceType: value,
        });
    }

    fetchDashboardData = () => {
        fetch('api/dashboard')
            .then(response => { return response.json() })
            .then(data => {
                this.setState({
                    data: data,
                    step: "create",
                    isLoading: false,
                });
            });
    }

    handlePreview = () => {

        this.setState({
            isLoading: true
        });

        fetch(`api/operations/tag/scenario/remove/preview`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                tagsToRemove: this.state.tagsToRemove,
                resourceType: this.state.resourceType
            })
        })
            .then(response => response.json())
            .then(data => {
                this.setState({
                    isLoading: false,
                    step: "preview",
                    preview: data
                });
                window.scrollTo(0, 0);
            });
    }

    handleSubmit = () => {
        this.setState({
            isLoading: true
        });

        fetch(`api/operations/tag/scenario/remove`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                tagsToRemove: this.state.tagsToRemove,
                resourceType: this.state.resourceType
            })
        }).then(_ => {
            this.props.history.push("/operations");
        });
    }

    handleBack = async () => {
        this.setState({
            step: "create"
        })
    }

    componentDidMount() {
        this.fetchDashboardData();
    }
}

export default ScenarioRemovePage;